import styled, { css } from 'styled-components';
import { layout, media } from '@prisjakt/ui-base';
import ToggleSearchButtonComponent from '../buttons/toggle-search-button';

export const PageHeader = styled.header`
  padding: 0;
`;

export const PageHeaderContent = styled.div`
  margin-top: 0.5em;
  margin-bottom: 0.5em;
  display: flex;
  flex-direction: column;
  padding: ${layout.measurements.spacing050};

  ${media.mediumDown`
    padding: 0;
  `}
`;

export const Title = styled.h1`
  font-size: ${layout.measurements.fontSizeNormal};
  font-weight: 600;

  ${media.mediumDown`
    padding: 0 ${layout.measurements.spacing100};
  `}
`;

type ItemsWrapperProps = {
  hasPadding?: boolean;
};

export const ItemsWrapper = styled.div<ItemsWrapperProps>`
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: ${layout.searchBar.height.desktop.value +
    layout.searchBar.borderWidth * 2}px;

  ${props =>
    props.hasPadding &&
    css`
      ${media.mediumDown`
      padding: 0 ${layout.measurements.spacing100};
    `}
    `}
`;

type PageHeaderContentItemProps = {
  hide?: boolean;
  wide?: boolean;
};

export const PageHeaderContentItem = styled.div<PageHeaderContentItemProps>`
  margin-right: 1.5em;

  &:last-child {
    margin-right: 0;
  }

  ${props =>
    props.hide &&
    css`
      ${media.mediumDown`
        display: none;
      `}
    `}

  ${props =>
    props.wide &&
    css`
      ${media.mediumDown`
        width: 100%;
      `}
    `}
`;

type ToggleSearchButtonProps = {
  hide: boolean;
};

export const ToggleSearchButton = styled(ToggleSearchButtonComponent)<
  ToggleSearchButtonProps
>`
  display: ${props => (props.hide ? 'none' : 'block')};
  white-space: nowrap;
`;

export const VersusText = styled.span`
  font-weight: normal;
`;
